import React from 'react';
import { motion } from 'framer-motion';

/**
 * A reusable component that fades in its children when they scroll into view.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - The content to animate.
 * @param {string} [props.className] - Optional CSS classes to apply to the wrapper.
 * @param {number} [props.delay] - Optional delay for the animation in seconds.
 */
const AnimatedOnScroll = ({ children, className = '', delay = 0 }) => {
  const itemVariants = {
    // The element is hidden and slightly down
    hidden: { opacity: 0, y: 20 },
    // The element animates to be visible and at its original position
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.6, 0.05, 0.01, 0.9], // A professional ease-out curve
        delay: delay,
      },
    },
  };

  return (
    <motion.div
      className={className}
      // --- THIS IS THE OPTIMIZATION ---
      // style={{ willChange: 'opacity, transform' }} <--- REMOVED: Causing excessive memory usage/flickering on mobile
      variants={itemVariants}
      initial="hidden"
      whileInView="visible" // Triggers the 'visible' state when in view
      // --- TRIGGER POINT UPDATED ---
      viewport={{ once: true, amount: 0.1 }} // Triggers once, when 10% is visible
    >
      {children}
    </motion.div>
  );
};

export default AnimatedOnScroll;